import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './App';
import './styles/index.css';
import { THEME_RENDER_CACHE_KEY } from './lib/api/preferences.api';

try {
  const cachedTheme = window.localStorage.getItem(THEME_RENDER_CACHE_KEY);
  if (cachedTheme === 'light' || cachedTheme === 'dark' || cachedTheme === 'system') {
    const effective = cachedTheme === 'system'
      ? (window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light')
      : cachedTheme;
    document.documentElement.dataset.theme = effective;
    document.documentElement.style.colorScheme = effective;
  }
} catch {
  // Theme cache is only a pre-auth rendering optimization.
}

const root = document.getElementById('root');
if (!root) throw new Error('Root element not found');

ReactDOM.createRoot(root).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
